<ng-template appPrefixContainer />

<ng-template #noPrefixComponent>
  <span class="error"><b>Error: </b>Prefix component '{{ field ? field.template : "??" }}' was not found.</span>
</ng-template>
